import { useNavigate } from "react-router-dom";
import { ChevronRight, Clock, LogOut, UserCircle, Wrench } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { useI18n } from "@/lib/i18n";
import { CLOSE_HOUR, OPEN_HOUR, SIZE_HEIGHTS, SIZES } from "@/lib/noleggio";
import { LangSwitch } from "@/components/Layout";

export default function Profile() {
  const { user, logout } = useAuth();
  const { t } = useI18n();
  const nav = useNavigate();
  return (
    <div className="max-w-2xl mx-auto px-5 md:px-8 pt-8 flex flex-col gap-3">
      <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight mb-2">{t("profile")}</h1>
      {user ? (
        <div data-testid="profile-card" className="mn-card p-4 flex items-center gap-4">
          <div className="w-14 h-14 rounded-full bg-[var(--brand-secondary)] flex items-center justify-center overflow-hidden text-xl font-extrabold text-[#283a2c]">
            {user.picture ? <img src={user.picture} alt="" className="w-full h-full object-cover" /> : user.name.slice(0, 1).toUpperCase()}
          </div>
          <div className="flex-1 min-w-0">
            <p data-testid="profile-name" className="font-bold">{user.name}</p>
            <p data-testid="profile-email" className="text-sm text-[var(--muted)] truncate">{user.email}</p>
            {user.role === "admin" && <p className="text-xs font-bold text-[var(--brand)] mt-1">{t("admin_role")}</p>}
          </div>
        </div>
      ) : (
        <div className="mn-card p-4 flex items-center gap-4">
          <UserCircle size={48} color="var(--muted)" />
          <div className="flex-1 flex flex-col gap-2">
            <p className="font-bold">{t("not_logged")}</p>
            <button data-testid="profile-login-button" className="mn-btn" onClick={() => nav("/accedi")}>{t("login_or_register")}</button>
          </div>
        </div>
      )}
      {user?.role === "admin" && (
        <button data-testid="admin-area-button" onClick={() => nav("/admin")} className="mn-card p-4 flex items-center gap-3 text-left hover:bg-[var(--brand-tertiary)] transition-colors">
          <Wrench size={22} color="var(--brand-primary)" />
          <span className="flex-1 font-semibold">{t("admin_area")}</span>
          <ChevronRight size={20} color="var(--muted)" />
        </button>
      )}
      <p className="mn-section">{t("language")}</p>
      <div className="mn-card p-4"><LangSwitch prefix="profile" /></div>
      <p className="mn-section">{t("size_guide")}</p>
      <div className="mn-card p-4 flex flex-col gap-3">
        {SIZES.map((s) => (
          <div key={s} className="flex items-center gap-3">
            <span className="w-9 h-7 rounded-md bg-[var(--brand-tertiary)] text-[var(--brand-primary)] font-extrabold flex items-center justify-center">{s}</span>
            <span>{t("height", { h: SIZE_HEIGHTS[s] })}</span>
          </div>
        ))}
      </div>
      <p className="mn-section">{t("shop_hours")}</p>
      <div className="mn-card p-4 flex items-center gap-3"><Clock size={20} color="var(--brand-primary)" /> {t("every_day", { o: OPEN_HOUR, c: CLOSE_HOUR })}</div>
      {user && (
        <button data-testid="logout-button" className="mn-btn mn-btn-ghost mt-2" onClick={() => { logout(); toast(t("logged_out")); }}>
          <LogOut size={18} /> {t("logout")}
        </button>
      )}
    </div>
  );
}
